import React from 'react';
import { useIntl } from 'react-intl';
import css from './SectionBlogs.module.css';
import { Icons } from '../../../components';
import { localizePath } from '../../../util/canonicalUrls';

const LOCATIONS = [
  {
    isFeatured: true,
    titleKey: 'SectionBlogs.post1.title',
    defaultTitle: 'How to Book Shooting Locations in Thailand Without the Hassle',
    img: 'https://res.cloudinary.com/dprwdukwm/image/upload/v1763450829/blog1_j9vfhr.jpg',
    path: '/blog/how-to-book-shooting-locations-in-thailand',
  },
  {
    titleKey: 'SectionBlogs.post2.title',
    defaultTitle: 'How to Make Money from Your Property by Listing It for Film Shoots',
    img: 'https://res.cloudinary.com/dprwdukwm/image/upload/v1763450829/blog2_newrso.jpg',
    path: '/blog/how-to-make-money-property-film-shoots',
  },
  {
    titleKey: 'SectionBlogs.post3.title',
    defaultTitle: "Working with a Small Crew? Here's How to Save on Location Costs",
    img: 'https://res.cloudinary.com/dprwdukwm/image/upload/v1763450831/blog3_zhufyk.jpg',
    path: '/blog/how-to-save-on-location-cost-in-thailand',
  },
  {
    titleKey: 'SectionBlogs.post4.title',
    defaultTitle: 'Top 15 Free Shooting Locations in Bangkok for Small Crews',
    img:
      'https://res.cloudinary.com/dprwdukwm/image/upload/v1764667302/9dcbfdd04ec8a124c959559faa5bd531490d28_c9dxqh.avif',
    path: '/blog/free-shooting-locations-in-bangkok-for-small-crews',
  },
  {
    titleKey: 'SectionBlogs.post5.title',
    defaultTitle: 'A Guide to Film Permits in Thailand: Who Needs Them and How to Get One',
    img:
      'https://res.cloudinary.com/dprwdukwm/image/upload/v1764667302/a0300d8c18596675295926a220b9fab2f4d2fb_ggnstm.avif',
    path: '/blog/guide-to-film-permits-in-thailand',
  },
  {
    titleKey: 'SectionBlogs.post6.title',
    defaultTitle:
      'How Location Managers Can Use SceneAccess to Deliver Locations Faster and Smarter',
    img:
      'https://res.cloudinary.com/dprwdukwm/image/upload/v1764667302/f6db22e30fe969235ea5699b52042502ea8a32_tm4fsn.avif',
    path: '/blog/how-locations-managers-can-use-sceneaccess',
  },
];

function SectionBlogs({ isBlogIndex = false }) {
  const intl = useIntl();

  const getBlogTitle = blog =>
    intl.formatMessage({ id: blog.titleKey, defaultMessage: blog.defaultTitle });
  const getBlogPath = blog => localizePath(blog.path, intl?.locale);

  const featuredPost = LOCATIONS.find(loc => loc.isFeatured);
  const otherPosts = LOCATIONS.filter(loc => !loc.isFeatured);

  return (
    <div className={css.sectionBlog}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>{intl.formatMessage({ id: 'SectionBlogs.title' })}</h2>
            <p>{intl.formatMessage({ id: 'SectionBlogs.subtitle' })}</p>
            {!isBlogIndex ? (
              <a className={css.blogIndexLink} href={localizePath('/blog', intl.locale)}>
                {intl.formatMessage({ id: 'SectionBlogs.allPosts' })}
              </a>
            ) : null}
          </div>
        </div>

        <div className={css.blogContentWrapper}>
          {featuredPost && (
            <div className={css.featuredPostWrapper}>
              <h3>{intl.formatMessage({ id: 'SectionBlogs.featuredPost' })}</h3>
              <div className={css.featuredPost}>
                <div className={css.blogImg}>
                  <img src={featuredPost.img} alt={getBlogTitle(featuredPost)} />
                </div>
                <div className={css.blogInfo}>
                  <h3>{getBlogTitle(featuredPost)}</h3>
                  <a href={getBlogPath(featuredPost)}>
                    {intl.formatMessage({ id: 'SectionBlogs.readMore' })}
                  </a>
                </div>
              </div>
            </div>
          )}

          <div className={css.carouselContainer}>
            <div className={css.carouselHead}>
              <h3>{intl.formatMessage({ id: 'SectionBlogs.allPosts' })}</h3>
              <div className={css.carouselArrows}>
                <button className={css.carouselArrowPrev}>
                  <Icons name="leftAngle" />
                </button>
                <button className={css.carouselArrowNext}>
                  <Icons name="rightAngle" />
                </button>
              </div>
            </div>

            <div className={css.blogSlider}>
              {otherPosts.map((blog, index) => (
                <div key={index} className={css.featuredPost}>
                  <div className={css.blogImg}>
                    <img src={blog.img} alt={getBlogTitle(blog)} />
                  </div>
                  <div className={css.blogInfo}>
                    <h3>{getBlogTitle(blog)}</h3>
                    <a href={getBlogPath(blog)}>
                      {intl.formatMessage({ id: 'SectionBlogs.readMore' })}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionBlogs;
